import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";
import { API_URL } from "./Constant";
import CloseIcon from "@mui/icons-material/Close";

const mockData = [
  { rank: 1, name: "Alice", time: "02:15" },
  { rank: 2, name: "Bob", time: "03:10" },
  { rank: 3, name: "Charlie", time: "03:45" },
  { rank: 4, name: "David", time: "04:05" },
  { rank: 5, name: "Eve", time: "04:20" },
  { rank: 6, name: "Frank", time: "05:00" },
  { rank: 7, name: "Grace", time: "05:15" },
  { rank: 8, name: "Hank", time: "06:30" },
  { rank: 9, name: "Ivy", time: "07:10" },
  { rank: 10, name: "Jack", time: "08:00" },
];

const ScoreboardPopup = ({ open, onClose, scoreboardData }) => {
  const [scores, setScores] = useState([]);
  const [playerId, setPlayerId] = useState(null);
  const [firstPlaceId, setFirstPlaceId] = useState(null);
  const isMobile = window.innerWidth <= 768;

  //  const PlayerTocken= localStorage.getItem('PlayerTocken');
  //  console.log("PlayerTocken",PlayerTocken)

  // useEffect(() => {
  //   if (scoreboardData) {
  //     console.log("scoreboardData",scoreboardData)
  //     setScores(scoreboardData);

  //   }
  // }, [scoreboardData]);
  useEffect(() => {
    if (!Array.isArray(scoreboardData) || scoreboardData.length === 0) return;

    console.log("Received scoreboardData:", scoreboardData);
    console.log("Decoded Player ID:", playerId);

    // Store original rankings before reordering
    const originalRanks = scoreboardData.map((player, index) => ({
      ...player,
      originalRank: index + 1, // Store original rank (1-based index)
    }));

    if (!playerId) {
      setScores(originalRanks);
      return;
    }

    const userIndex = originalRanks.findIndex(
      (player) => player.player_id === playerId,
    );

    if (userIndex !== -1) {
      // If user exists in the scoreboard, move them to the top
      const user = originalRanks[userIndex];
      const filteredScores = originalRanks.filter(
        (player) => player.player_id !== playerId,
      );
      setScores([user, ...filteredScores]);
    } else {
      // If user is NOT in the scoreboard, display as is
      setScores(originalRanks);
    }
  }, [scoreboardData, playerId]);

  const getRankIcon = (rank) => (rank === 1 ? "🥇" : rank);
  useEffect(() => {
    const fetchPlayerId = async () => {
      const playerToken = localStorage.getItem("PlayerTocken");
      if (!playerToken) return;

      try {
        const response = await axios.post(
          `${API_URL}/get_player_id_with_tocken`,
          {
            PlayerTocken: playerToken,
          },
        );
        // console.log("response.............",response)
        setPlayerId(response.data.playerId);
      } catch (error) {
        console.error("Error fetching player ID:", error);
      }
    };

    fetchPlayerId();
  }, []);
  // useEffect(() => {
  //   setScores(mockData);
  // }, []);

  // const getRankIcon = (rank) => {
  //   switch (rank) {
  //     case 1:
  //       return "🥇";
  //     // case 2:
  //     //   return "🥈";
  //     // case 3:
  //     //   return "🥉";
  //     default:
  //       return rank;
  //   }
  // };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          background: "radial-gradient(circle at top, #003b80, #001a33)",
          borderRadius: "20px",
          overflow: "hidden",
          border: "2px solid rgba(0, 238, 255, 0.3)",
          boxShadow: "0 0 30px rgba(0, 238, 255, 0.5)",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          background: "radial-gradient(circle at top, #003b80, #001a33)",
          color: "white",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(0, 238, 255, 0.5)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgba(0, 238, 255, 0.1)",
          },
        }}
      >
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              mb: 3,
              textAlign: "center",
              textShadow: "0 0 10px #00eaff, 0 0 20px #00eaff",
              fontFamily: "'Orbitron', sans-serif",
              animation: "glow 2s infinite alternate",
            }}
          >
            SCOREBOARD
          </Typography>
        </motion.div>

        {/* Leaderboard List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {scores.map((player, index) => {
            const isCurrentUser = player.player_id === playerId;
            const isOriginalFirst = player.player_id === firstPlaceId; // Check if the player was originally first

            return (
              <motion.div
                key={player.player_id}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: isCurrentUser
                    ? "0 0 25px rgba(255, 20, 147, 0.8)" // Pink glow for current user
                    : "0 0 25px rgba(0, 238, 255, 0.8)",
                  border: isCurrentUser
                    ? "3px dashed rgba(255, 20, 147, 0.8)" // Pink border for current user
                    : "2px dashed rgba(0, 238, 255, 0.7)",
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderRadius: "10px",
                  background: isCurrentUser
                    ? "rgba(255, 20, 147, 0.1)" // Light pink background for current user
                    : "rgba(0, 238, 255, 0.1)", // Blue background for others
                  boxShadow: isCurrentUser
                    ? "0 0 15px rgba(255, 20, 147, 0.8)" // Pink glow for current user
                    : "0 0 15px rgba(0, 238, 255, 0.5)",
                  border: isCurrentUser
                    ? "3px dashed rgba(255, 20, 147, 0.8)" // Pink border for current user
                    : "2px dashed rgba(0, 238, 255, 0.7)",
                  cursor: "pointer",
                }}
              >
                {/* Rank Icon (Use Pink or Blue Based on Current User) */}
                <Box
                  sx={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "8px",
                    background: isCurrentUser
                      ? "radial-gradient(circle at top, #800033, #4d0020)" // Dark pink gradient
                      : "radial-gradient(circle at top, #003b80, #001a33)", // Blue gradient
                    boxShadow: isCurrentUser
                      ? "0 0 15px rgba(255, 20, 147, 0.9), 0 0 25px rgba(255, 20, 147, 0.5)" // Pink glow
                      : "0 0 15px rgba(0, 170, 255, 0.9), 0 0 25px rgba(0, 170, 255, 0.5)", // Blue glow
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: { md: "18px", xs: "12px" },
                    color: isCurrentUser ? "#ff1493" : "#00aaff", // Pink for current user, blue for others
                    fontFamily: "Roboto",
                    position: "relative",
                  }}
                >
                  {/* Show original rank icon */}
                  {getRankIcon(player.originalRank)}

                  {/* Show medal ONLY for the original first-place player */}
                  {/* {player.originalRank === 1 && (
                  <img
                    src="/path-to-your-medal-icon.png" // Replace with the correct image path
                    alt="Medal"
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      width: "24px",
                      height: "24px",
                    }}
                  />
                )} */}
                </Box>

                {/* Player Name (Pink for Current User) */}
                <Typography
                  className="player-name"
                  sx={{
                    fontSize: { md: "18px", xs: "12px" },
                    fontWeight: "bold",
                    color: isCurrentUser ? "#ff1493" : "#00ccff", // Pink or blue
                    textShadow: isCurrentUser
                      ? "0 0 8px #ff1493, 0 0 16px #ff0066" // Pink glow for current user
                      : "0 0 8px #00ccff, 0 0 16px #0077ff", // Blue glow for others
                    fontFamily: "Roboto",
                  }}
                >
                  {isMobile && player.name.length > 12
                    ? `${player.name.slice(0, 12)}...`
                    : player.name}
                </Typography>

                {/* Player Time (Pink for Current User) */}
                <Typography
                  sx={{
                    fontSize: { md: "18px", xs: "12px" },
                    fontWeight: "bold",
                    color: isCurrentUser ? "#ff66b2" : "#00eaff", // Pink for current user, blue for others
                    fontFamily: "Roboto",
                  }}
                >
                  ⏱ {player.time}
                </Typography>
              </motion.div>
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ScoreboardPopup;
